const STARS = [
  { left: '6%', top: '20%', size: 1.5 }, { left: '16%', top: '12%', size: 2 }, { left: '28%', top: '30%', size: 1.5 },
  { left: '40%', top: '14%', size: 1.5 }, { left: '52%', top: '24%', size: 2 }, { left: '64%', top: '16%', size: 1.5 },
  { left: '76%', top: '28%', size: 1.5 }, { left: '88%', top: '18%', size: 2 }, { left: '94%', top: '35%', size: 1.5 },
  { left: '22%', top: '42%', size: 1.5 }, { left: '70%', top: '44%', size: 1.5 },
];

// Shared dark navy banner used at the top of every inner page.
// Keep this the single source of the "hero navy" so pages never drift out of sync.
export function PageHeader({ eyebrow, title, children, compact = false }) {
  return (
    <div
      className={`relative pt-32 text-center overflow-hidden ${compact ? 'pb-16' : 'pb-20'}`}
      style={{ background: 'linear-gradient(160deg, #060e1e 0%, #0c2048 50%, #162d66 100%)' }}
    >
      <div className="absolute inset-0 pointer-events-none">
        {STARS.map((s, i) => (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              left: s.left, top: s.top, width: s.size, height: s.size,
              background: 'rgba(255,255,240,0.8)',
              boxShadow: '0 0 3px 1px rgba(255,255,220,0.4)',
            }}
          />
        ))}
      </div>

      <div className="relative z-10">
        <p className="font-mono text-gold-400/70 uppercase tracking-wider text-xs mb-3 font-semibold">{eyebrow}</p>
        <h1 className="font-display text-4xl md:text-5xl text-cream-50 mb-6">{title}</h1>
        {children}
      </div>
    </div>
  );
}
